import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { createPortal } from 'react-dom';
import css from './Select.module.scss';
import Check from '../icons/Check';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var optionsId = 'ov-options';
export var optionsDiv = function optionsDiv() {
  var div = document.querySelector("#".concat(optionsId));

  if (div) {
    return div;
  }

  div = document.createElement('div');
  div.id = optionsId;
  document.body.appendChild(div);
  return div;
};
/* eslint-disable react/no-array-index-key */

var Options = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref2;

  var flip = _ref.flip,
      id = _ref.id,
      left = _ref.left,
      long = _ref.long,
      onChange = _ref.onChange,
      open = _ref.open,
      options = _ref.options,
      top = _ref.top,
      value = _ref.value;
  return /*#__PURE__*/createPortal( /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      "aria-hidden": open ? undefined : true,
      className: cc([css.options, (_ref2 = {}, _defineProperty(_ref2, css.flip, flip), _defineProperty(_ref2, css.on, open), _defineProperty(_ref2, css.long, long), _ref2)]),
      ref: ref,
      style: {
        left: left,
        top: top
      },
      children: /*#__PURE__*/_jsx("div", {
        className: css.optionsList,
        id: id,
        role: "listbox",
        tabIndex: open ? 0 : -1,
        children: options.map(function (option, idx) {
          var buttonProps = {
            'aria-label': option.ariaLabel ? option.ariaLabel : "Select ".concat(option.label),
            className: cc([css.optionButton, _defineProperty({}, css.optionButtonDisabled, option.disabled)]),
            disabled: option.disabled,
            onClick: function onClick() {
              onChange(option.value);
            },
            role: 'option',
            tabIndex: open ? 0 : -1
          };

          if (option.value === value) {
            buttonProps['aria-selected'] = true;
          }

          return /*#__PURE__*/_createElement("button", _objectSpread(_objectSpread({}, buttonProps), {}, {
            key: "".concat(option.value, "-").concat(idx),
            type: "button"
          }), option.label, option.value === value && /*#__PURE__*/_jsx(Check, {
            className: css.optionIcon
          }));
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      "aria-hidden": "true",
      className: cc([css.optionsBg, _defineProperty({}, css.on, open)])
    })]
  }), optionsDiv());
});
Options.propTypes = {
  id: PropTypes.string,
  flip: PropTypes.bool.isRequired,
  left: PropTypes.number.isRequired,
  long: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  top: PropTypes.number.isRequired,
  value: PropTypes.oneOfType([PropTypes.shape(), PropTypes.bool, PropTypes.number, PropTypes.string])
};
export default Options;